import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Gift = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12.25 6.5625V11.375C12.25 11.6071 12.1578 11.8296 11.9937 11.9937C11.8296 12.1578 11.6071 12.25 11.375 12.25H3.0625C2.83044 12.25 2.60788 12.1578 2.44378 11.9937C2.27969 11.8296 2.1875 11.6071 2.1875 11.375V6.5625M7 2.84375C7 2.5409 6.91019 2.24485 6.74194 1.99303C6.57368 1.74122 6.33453 1.54496 6.05473 1.42906C5.77493 1.31316 5.46705 1.28284 5.17002 1.34192C4.87298 1.40101 4.60014 1.54684 4.38599 1.76099C4.17184 1.97514 4.02601 2.24799 3.96692 2.54502C3.90784 2.84205 3.93816 3.14994 4.05406 3.42973C4.16996 3.70953 4.36622 3.94868 4.61803 4.11694C4.86985 4.28519 5.1659 4.375 5.46875 4.375H7M7 2.84375V4.375M7 2.84375C7 2.5409 7.08981 2.24485 7.25806 1.99303C7.42632 1.74122 7.66547 1.54496 7.94527 1.42906C8.22506 1.31316 8.53295 1.28284 8.82998 1.34192C9.12701 1.40101 9.39986 1.54684 9.61401 1.76099C9.82816 1.97514 9.97399 2.24799 10.0331 2.54502C10.0922 2.84205 10.0618 3.14994 9.94594 3.42973C9.83004 3.70953 9.63378 3.94868 9.38197 4.11694C9.13015 4.28519 8.8341 4.375 8.53125 4.375H7M7 4.375V12.25M1.96875 6.5625H12.4687C12.831 6.5625 13.125 6.2685 13.125 5.90625V5.03125C13.125 4.669 12.831 4.375 12.4687 4.375H1.96875C1.6065 4.375 1.3125 4.669 1.3125 5.03125V5.90625C1.3125 6.2685 1.6065 6.5625 1.96875 6.5625Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 14 14" strokeWidth={0.9}>{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Gift };